import "./chunk--chunk-Z7A6LSGX.vbt.js";

// src/js/components/YotpoStarWidget.js
var YotpoStarWidget = class {
  constructor(el, sel) {
    const id = el.getAttribute(sel);
    const appendString = el.getAttribute("data-append-string");
    this.htmlUpdated = false;
    const observer = new MutationObserver(async function() {
      const ypEl = el.querySelector(".yotpo-bottom-line-scroll-panel");
      if (ypEl) {
        const res = await fetch(`https://api.yotpo.com/products/${window.yotpoAppKey}/${id}/qna_bottomline`);
        const json = await res.json();
        if (!json.response) {
          this.disconnect();
          return;
        }
        ypEl.querySelectorAll("svg").forEach((el2) => {
          el2.setAttribute("height", "10px");
          el2.setAttribute("width", "10px");
          el2.style.marginTop = "-1px";
          el2.querySelector("path").style.fill = "var(--color-gray-dark)";
          el2.querySelector("path").style.stroke = "var(--color-gray-dark)";
        });
        ypEl.querySelectorAll("*").forEach((el2) => {
          el2.style.fontSize = "10px";
          el2.style.lineHeight = "10px";
        });
        ypEl.querySelector(".yotpo-sr-bottom-line-summary").firstElementChild.style.marginRight = "5px";
        if (!this.htmlUpdated) {
          ypEl.innerHTML += `
            <div style='display:inline;margin-bottom:2px'>&nbsp;|&nbsp;</div><span data-qa-trigger class="answered-qn-pdp" style="font-size: 10px; line-height: 10px; cursor: pointer">${json.response.total_answers} ${appendString}</span>
          `;
          this.htmlUpdated = true;
        }
        el.classList.remove("hidden");
        ypEl.addEventListener("click", (e) => {
          const yotpoSection = document.querySelector(".yotpo-widget-instance .yotpo-reviews-main-widget");
          if (yotpoSection) {
            window.scrollTo({
              behavior: "smooth",
              top: yotpoSection.getBoundingClientRect().top + window.scrollY - 135
            });
          }
          if (e.target.hasAttribute("data-qa-trigger")) {
            document.querySelectorAll(".ugc-storefront-widgets-tabs-container__tab")[1].click();
          } else {
            document.querySelectorAll(".ugc-storefront-widgets-tabs-container__tab")[0].click();
          }
        });
        ypEl.style.cursor = "pointer";
        this.disconnect();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
};
var YotpoStarWidget_default = YotpoStarWidget;
export {
  YotpoStarWidget_default as default
};
